import { render, staticRenderFns } from "./LayoutCenter.vue?vue&type=template&id=f10abc82&scoped=true&"
var script = {}
import style0 from "./LayoutCenter.vue?vue&type=style&index=0&id=f10abc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10abc82",
  null
  
)

export default component.exports